import CommandService from '../../../services/commands/CommandService';
import dataset from '../../slices/dataset';
import { createAppListener, postDispatch } from '../listenerHelpers';

const cacheManagementListener = createAppListener();

const commandService = new CommandService();

cacheManagementListener.startListening(
  postDispatch(dataset.dispose, ({ datasetId }) => {
    commandService.clearCacheBy(datasetId);
  })
);

export default cacheManagementListener.middleware;
